import { useApiQuery, useApiMutation } from "../services/react-query";
import { callDownloadApi } from "../services/api";

export const renderBadgePdf = ({ badgeId, ticketId }) =>
  callDownloadApi({
    url: `/badges/${badgeId}/render`,
    method: "POST",
    body: { ticketId, mode: "print" },
    token: localStorage.getItem("token"),
    download: false,
  });

export const useCreateBadgeTemplate = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "badgeTemplates" },
    fetchOptions: { url: "/badges", method: "POST" },
    invalidateQueryKeys: [["badgeTemplates"]],
    successMessage: {
      title: "Badge template has been created",
      color: "green",
    },
  });

export const useGetBadgeTemplates = (params) =>
  useApiQuery({
    queryOptions: { queryKey: ["badgeTemplates", params] },
    fetchOptions: { url: "/badges", method: "GET", params },
  });

export const useGetBadgeTemplate = (id) =>
  useApiQuery({
    queryOptions: { queryKey: ["badgeTemplate", { id }], enabled: !!id },
    fetchOptions: { url: `/badges/${id}`, method: "GET" },
  });

export const useUpdateBadgeTemplate = ({ id }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useUpdateBadgeTemplate" },
    fetchOptions: { url: `/badges/${id}`, method: "PATCH" },
    invalidateQueryKeys: [["badgeTemplate"], ["badgeTemplates"]],
    successMessage: {
      title: "Badge template has been updated",
      color: "green",
    },
  });

export const useDeleteBadgeTemplate = ({ id }) =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteBadgeTemplate" },
    fetchOptions: { url: `/badges/${id}`, method: "DELETE" },
    invalidateQueryKeys: [["badgeTemplates"]],
    successMessage: {
      title: "Badge template has been deleted",
      color: "green",
    },
  });
